/**
 * About
 */

	const siteAboutOverlayEl = document.querySelector('.about--purpose-title')

	const siteAboutOverlay = () => {
		siteAboutOverlayEl.nextElementSibling.style.setProperty('--offset', `${siteAboutOverlayEl.offsetHeight}px`)
	}

	if (siteAboutOverlayEl) {
		window.addEventListener('load', _ => {
			siteAboutOverlay()
		})

		window.addEventListener('resize', _ => {
			setTimeout(() => {
				siteAboutOverlay()
			}, 100);
		})
	}
